import dayjs from 'dayjs';
import { NavLink } from 'react-router-dom';

import { ABBREVIATED_DATE_FORMAT } from 'common';
import css from './HomePage.module.scss';
import { Tooltip } from '@epam/promo';
import { HomeData } from './useGetHomeData';

interface HomeSectionProps extends HomeData {
  isLoading: boolean;
}

export const HomeSection = ({
  title,
  tooltip,
  icon,
  navigateLink,
  items,
  isLoading,
}: HomeSectionProps) => {
  if (isLoading) {
    return <div className={`${css.block} skeleton-loader`} />;
  }

  return (
    <div className={css.block}>
      <div className={css.header}>
        {icon}
        <Tooltip content={tooltip} maxWidth={350}>
          <h3>{title}</h3>
        </Tooltip>
      </div>

      <div className={css.items__wrapper}>
        {items.map((item, i) => (
          <NavLink
            key={i}
            className={css.item__container}
            to={navigateLink(item.id)}>
            <span className={css.item__date}>
              {dayjs(item.date || undefined).format(ABBREVIATED_DATE_FORMAT)}
            </span>
            <span className={css.item__dot} />
            <Tooltip content={item.title}>
              <span className={css.item__title}>{item.title}</span>
            </Tooltip>
          </NavLink>
        ))}
      </div>
    </div>
  );
};
